import { useThunkDispatch } from '@campaignhub/react-hooks'

import * as clientActions from '@redux/modules/clientV4'

import usePaginatedLoader from './usePaginatedLoader'

const importClients = (dispatch) => {
  const { importClientsV4: createFn } = clientActions
  return dispatch(createFn({}))
}

function useClientsV4(options = {}){
  const { searchFilter, selectedClassification } = options

  const dispatch = useThunkDispatch()

  const { items: filteredClientsV4, loading, hasMore, callbacks } = usePaginatedLoader({
    loadFn: clientActions.loadClientsV4,
    entityKey: 'clientsV4',
    queryOptions: {
      name: searchFilter || '',
      classification: selectedClassification,
    },
  })

  return {
    filteredClientsV4,
    loading,
    hasMore,
    callbacks: {
      ...callbacks,
      importClients: () => importClients(dispatch),
    },
  }
}

export default useClientsV4
